import { Box, Flex, HStack, Link, Text } from "@chakra-ui/react"
import React from "react"
import styled from "styled-components"
import { globalStyleVariables } from "../styles/variables"

const BannerHeading = styled(Text)`
    &::before {
        content: "🚀 Remove background with AI - Now 90% cheaper!";
    }
    
    color: white;
    font-weight: bold;
    font-size: var(--chakra-fontSizes-sm);

    @media (${globalStyleVariables.MOBILE_MEDIA_QUERY}) {
        &::before {
            content: "AI background removal 90% cheaper!";
        }
    }
`

const ProductHuntBadge = () => {
    return (
        <a
            href="https://www.producthunt.com/posts/imagekit-website-analyzer?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-imagekit&#0045;website&#0045;analyzer"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                textDecoration: 'none',
            }}
        >
            <img
                src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=677229&theme=light&v=${new Date().getTime()}`}
                alt="ImageKit Website Analyzer - Free tool to automate media performance monitoring | Product Hunt"
                style={{
                    height: '30px', // Reduced height
                }}
                height="30" // Reflect reduced height in attributes
            />
        </a>
    );
};

const TopBanner = ({ link, linkText = "Learn more" }) => {
    return (
        <Link textDecoration={"none"} href="https://imagekit.io/docs/ai-transformations#imagekit-background-removal-e-bgremove">
            <HStack
                background={"#1a1a1a"}
                h="42px"
                alignItems={"center"}
                justifyContent={"center"}>
                <BannerHeading></BannerHeading>
                {/* <Box color={"white"}>
                    🚀 Webinar: Building native video experiences
                </Box> */}
                {/* <Box color={"white"} display={{ base: "none", md: "inline-flex" }}>
                    <ProductHuntBadge />
                </Box> */}
                <Link
                    href={"https://imagekit.io/docs/ai-transformations#imagekit-background-removal-e-bgremove"}
                    color="white"
                    fontSize="sm"
                    fontWeight="bold"
                    textDecoration={"underline"}
                    textUnderlineOffset={"4px"}
                    target="_blank">
                    View Docs →
                </Link>
            </HStack>
        </Link>
    )
}

export default TopBanner

